import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import {
  clearFilterHandler,
  fetchHotelSearchPrice,
  getClearFilters,
  getHotelFilters,
  getHotelPriceFilters,
  getHotelSearched,
  getLoading,
  getNoRooms,
  hotelSearchAsync,
  resetPriceLoading,
} from "../../../features/bookings/hotelSlice";
import { getLogin } from "../../../features/userSlice";
import { scrollFunc } from "../../../helpers/helper";
import Loader from "../../../helpers/Loader";
import { errorToast } from "../../../helpers/toaster";
import Fliter from "../../common/filter/Fliter";
import HotelFilter from "../../common/filter/HotelFilter";
import PriceFilter from "../../common/filter/PriceFilter";
import StarRating from "../../common/filter/StarRating";
import HotelList from "./HotelList";
import NoRooms from "./NoRooms";

const Hotel = () => {
  const [searchParams] = useSearchParams();
  const [val, setVal] = useState([]);
  const [uiLoader, setUiLoader] = useState(true);
  const [max, setMax] = useState(100);
  const [min, setMin] = useState(0);
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );

  const dispatch = useDispatch();
  const priceRangeRef = React.useRef("");
  const priceFilterRef = React.useRef("");
  const userDatas = useSelector(getLogin);
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  let loading = useSelector(getLoading);

  const hotelSearched = useSelector(getHotelSearched);
  const clearFilter = useSelector(getClearFilters);
  const hotelsPrice = useSelector((state) => state.hotel.hotelsPrice);
  const noRooms = useSelector(getNoRooms);
  const starFilter = useSelector(getHotelFilters);
  const hotelPriceFilter = useSelector(getHotelPriceFilters);
  const [backup, setBackup] = useState([]);
  const [starFlag, setStarFlag] = useState(false);
  const [priserangeval, setPriserangeval] = useState(0);

  const [minPrice, setMinPirce] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [resetFilter, setResetFilter] = useState(false);
  const [respFilter, setRespFilter] = useState(false);
  const [previousLogin, setPreviousLogin] = useState(
    Object.keys(userData).length
  );

  const hotelScroll = useRef(null);

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      if (previousLogin === 0 && userData?.role === "Agent") {
        setPreviousLogin(1);
      }
    }
  }, [userDatas]);

  const getPrice = (code) => {
    let val = hotelsPrice.filter((ele) => {
      return parseInt(ele.HotelCode) === parseInt(code);
    });
    return val;
  };

  const resFilterNavigation = (type) => {
    if (type === "open") {
      setRespFilter(true);
    } else {
      setRespFilter(false);
    }
  };

  useEffect(() => {
    var data = Object.fromEntries([...searchParams]);
    if (Object.keys(data).length > 0) {
      dispatch(fetchHotelSearchPrice({ data, Authorization }));
      dispatch(hotelSearchAsync({ data, Authorization }));
      setMaxPrice(0);
    }
  }, [searchParams, previousLogin]);

  useEffect(() => {
    if (loading) {
      setUiLoader(true);
    } else {
      setUiLoader(false);
    }
  }, [loading]);

  const priceFilter = (hotelSearched) => {
    let arr = [];

    let priced = hotelSearched.filter((ele) => getPrice(ele.code).length > 0);

    priced.map((hotel, ind) => {
      hotelsPrice.map((ele) => {
        if (parseInt(hotel.code) === parseInt(ele.HotelCode)) {
          priced[ind] = { ...priced[ind], priceDatas: ele.Rooms[0].TotalFare };
        }
      });
    });

    var MinPrices = Math.min(...priced.map((price) => price.priceDatas));
    var MaxPrices = Math.max(...priced.map((price) => price.priceDatas)) + 100;
    if (MaxPrices > 0) {
      setMinPirce(0);
      setMaxPrice(MaxPrices);
    }

    setTimeout(() => {
      let max = Math.max(Math.max(...priced.map((o) => o.priceDatas))) + 50;
      let min = 0;
      setMax(0);
      if (max > 0) {
        setMax(max);
        setMin(min);
        setPriserangeval(min);
        priceRangeRef.current.value = min;
      }
      setUiLoader(false);
    }, 500);

    arr = [
      ...priced,
      ...hotelSearched.filter((ele) => !getPrice(ele.code).length > 0),
    ];

    setVal(arr);
    setBackup(arr);
  };

  React.useMemo(() => {
    hotelScroll.current?.scrollIntoView({ behavior: "smooth" });
    hotelsPrice.length > 0 && priceFilter(hotelSearched);
  }, [hotelsPrice]);
  React.useMemo(() => {
    hotelScroll.current?.scrollIntoView({ behavior: "smooth" });
    priceFilter(hotelSearched);
  }, [hotelSearched]);

  const FilterHandler = (data, fType) => {
    const PriceSort = data["PriceSort"];
    const PriceRange = data["PriceRange"];
    const PriceFilter = data["PriceFilter"];
    const Rating = data["Rating"];
    const NameFilter = data["NameFilter"];
    const Reset = data["Reset"];

    var tempHotel = backup;

    //Price Sort

    if (PriceSort !== undefined && PriceSort.length > 0) {
      var storeZero = [];
      tempHotel = tempHotel.filter((price) => {
        price.priceDatas === 0 && storeZero.push(price);
        return price.priceDatas > 0;
      });

      if (PriceSort[0] === "MinToMax") {
        tempHotel = [
          ...tempHotel.sort(
            (a, b) => parseFloat(a.priceDatas) - parseFloat(b.priceDatas)
          ),
        ];
      }

      if (PriceSort[0] === "MaxToMin") {
        tempHotel = [
          ...tempHotel.sort(
            (a, b) => parseFloat(b.priceDatas) - parseFloat(a.priceDatas)
          ),
        ];
      }

      tempHotel = [...tempHotel, ...storeZero];
    }

    //PRICE RANGE

    if (PriceRange.length > 0) {
      tempHotel = tempHotel.filter(
        (p) => p.priceDatas >= PriceRange[0] && p.priceDatas <= PriceRange[1]
      );
    }

    // RATING
    if (Rating.length > 0) {
      tempHotel = tempHotel.filter((t) =>
        Rating.length > 0 ? Rating.includes(t.rating.toString()) : true
      );
    }

    // pricewise filtering
    if (PriceFilter.length > 0 && PriceFilter !== undefined) {
      var arrp = [];
      PriceFilter.map((val) => {
        let max = parseInt(val.split("-")[1]);

        if (typeof val.split("-")[1] === "undefined") {
          max = 9999999999999999999999999999999;
        }
        arrp.push(
          ...tempHotel.filter(
            (ele) =>
              ele.priceDatas >= parseInt(val.split("-")[0]) &&
              ele.priceDatas <= max
          )
        );
      });
      tempHotel = arrp;
    }

    if (NameFilter !== "" && NameFilter !== undefined) {
      tempHotel = [
        ...tempHotel.filter((ele) =>
          ele.name.toLowerCase().includes(NameFilter.toLowerCase())
        ),
      ];
    }

    if (Reset) {
      tempHotel = backup;
      setMaxPrice("");
      setMinPirce("");
      setTimeout(() => {
        setMaxPrice(maxPrice);
        setMinPirce(0);
      }, 300);

      setResetFilter(true);
    }

    setVal(tempHotel);
  };

  return (
    <>
      <section className="hotel-listing-main" ref={hotelScroll}>
        <div
          className={respFilter ? "filter-backdrop active" : "filter-backdrop"}
          onClick={() => resFilterNavigation("close")}
        ></div>
        <div
          className={respFilter ? "navigation navigation-active" : "navigation"}
        >
          <HotelFilter
            maxp={maxPrice}
            minp={minPrice}
            noRooms={noRooms}
            Reset={resetFilter}
            filterData={(data) => {
              FilterHandler(data);
            }}
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xl-3 for-desktop-screen">
              <HotelFilter
                maxp={maxPrice}
                minp={minPrice}
                noRooms={noRooms}
                Reset={resetFilter}
                filterData={(data) => {
                  FilterHandler(data);
                }}
              />
            </div>
            <div className="col-xl-9 mt-4 position-relative">
              <div className="responsive-sidebar">
                <div>
                  <div
                    className="nav-btn"
                    onClick={() => resFilterNavigation("open")}
                  >
                    <img
                      src="assets/images/filter-icon.svg"
                      className="filter-icon"
                      alt="filter-icon"
                    />
                  </div>
                </div>
                <div className="flight-breadcrumb">
                  <div aria-label="breadcrumb">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Hotel Listing
                      </li>
                    </ol>
                  </div>
                </div>
              </div>

              {uiLoader ? (
                <div className="hotel-listing-wrap gray-border">
                  <div className="main">
                    <div className="structure-div1 loader-bg"></div>
                    <div className="d-flex justify-content-between structure2-main">
                      <div className="loader-bg structure-div2"></div>
                      <div className="loader-bg structure-div2"></div>
                      <div className="loader-bg structure-div2"></div>
                      <div className="loader-bg structure-div2"></div>
                    </div>
                  </div>
                  <div className="hotel-detail-lists">
                    <div className="d-flex">
                      <span className="loader-bg p-3 mb-2 d-inline-block w-25 me-2 rounded"></span>
                      <span className="loader-bg p-3 mb-2 d-inline-block w-25 rounded"></span>
                    </div>
                    <h4 className="loader-bg p-2 mb-2"></h4>
                    <div className="loader-bg p-2 mb-2"></div>
                    <div className="loader-bg p-4 mb-2"></div>
                    <div className="d-flex">
                      <span className="loader-bg p-3 mb-2 d-inline-block  me-2 rounded"></span>
                      <span className="loader-bg p-3 mb-2 d-inline-block w-25 me-2 rounded"></span>
                      <span className="loader-bg p-3 mb-2 d-inline-block  rounded me-2"></span>
                      <span className="loader-bg p-3 mb-2 d-inline-block w-25 me-2 rounded"></span>
                    </div>
                  </div>
                </div>
              ) : val.length > 0 ? (
                val.map((ele, ind) => {
                  return (
                    <HotelList
                      key={ind}
                      priced={hotelsPrice}
                      vals={ele}
                      qData={queryData}
                      hotelPrice={
                        ele.priceDatas !== undefined && ele.priceDatas
                      }
                    />
                  );
                })
              ) : (
                <NoRooms noRooms={noRooms} nohotel={val.length === 0} />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hotel;
